import './styles/AlertTemplate.scss';

const icons: { [key: string]: JSX.Element } = {
    success: <path d="M5 12.5l4.5 4.5L19 7.5" />,
    error: <><path d="M12 7v7" /><path d="M12 17.5h.01" /></>,
    info: <><path d="M12 11v6" /><path d="M12 7.5h.01" /></>,
};

export default function AlertTemplate({ style, options, message, close }: any) {
    const type = options.type ?? "info";

    return (
        <div style={style} className="toastWrap">
            <div className={"toast " + type}>
                <span className="tIcon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        {icons[type] ?? icons.info}
                    </svg>
                </span>
                <span className="tMsg">{message}</span>
                <span className="tClose" onClick={close} aria-label="Zavřít">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                        <path d="M6 6l12 12M18 6L6 18" />
                    </svg>
                </span>
            </div>
        </div>
    );
}
